import { Action, createReducer, on } from "@ngrx/store";

import { SharedActions } from "./shared.actions";
import { initialState, SharedState } from "./shared.store";

export const sharedReducer = createReducer(
  initialState,

  on(SharedActions.setFilterProfilesAsJson, (state, { filterProfilesAsJson }): SharedState => ({
    ...state,
    filterProfilesAsJson: filterProfilesAsJson
  })),

  on(SharedActions.getAllFilterProfiles, (state): SharedState => ({
    ...state,
  })),
  on(SharedActions.getAllFilterProfilesSuccess, (state, { filterProfiles }): SharedState => ({
    ...state,
    filterProfiles: filterProfiles,
  })),
  on(SharedActions.getAllFilterProfilesError, (state, { payload }) => ({
    ...state,
    getAllFilterProfilesError: payload,
  })),

  on(SharedActions.postCreateProfile, (state, { filterModel }): SharedState => ({
    ...state,
    filterModel: filterModel,
  })),
  on(SharedActions.postCreateProfileSuccess, (state): SharedState => ({
    ...state,
    profileCreated: true
  })),
  on(SharedActions.postCreateProfileError, (state, { payload }) => ({
    ...state,
    postCreateProfileError: payload,
  })),

  on(SharedActions.putUpdateFilter, (state, { id, filterModel }): SharedState => ({
    ...state,
    filterId: id,
    filterModel: filterModel,
  })),
  on(SharedActions.putUpdateFilterSuccess, (state): SharedState => ({
    ...state,
  })),
  on(SharedActions.putUpdateFilterError, (state, { payload }) => ({
    ...state,
    putUpdateFilterError: payload,
  })),

  on(SharedActions.deleteFilter, (state, { id }): SharedState => ({
    ...state,
    filterId: id
  })),
  on(SharedActions.deleteFilterSuccess, (state): SharedState => ({
    ...state,
  })),
  on(SharedActions.deleteFilterError, (state, { payload }) => ({
    ...state,
    deleteFilterError: payload,
  })),

  on(SharedActions.getSourceTypes, (state): SharedState => ({
    ...state
  })),
  on(SharedActions.getSourceTypesSuccess, (state, { sourceTypes }): SharedState => ({
    ...state,
    sourceTypes: sourceTypes
  })),
  on(SharedActions.getSourceTypesError, (state, { payload }) => ({
    ...state,
    getSourceTypesError: payload,
  })),

  on(SharedActions.getFeatureTypes, (state): SharedState => ({
    ...state
  })),
  on(SharedActions.getFeatureTypesSuccess, (state, { featureTypes }): SharedState => ({
    ...state,
    featureTypes: featureTypes
  })),
  on(SharedActions.getFeatureTypesError, (state, { payload }) => ({
    ...state,
    getFeatureTypesError: payload,
  }))
);

export function reducer(state: SharedState | undefined, action: Action) {
  return sharedReducer(state, action);
}
